import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AuthServiceService } from '../../services/authentication.service';
import { Subject, takeUntil, Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { IconService } from '../../services/icons.service';

@Component({
  selector: 'app-navmenu',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.sass']
})
export class NavmenuComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private subscriptions = new Subscription();
  private notificationTimeoutId?: ReturnType<typeof setTimeout>;

  swaggerUrl = environment.apiUrl.replace(/\/api(?!.*\/api)/, '/swagger');
  isDiscordBotRunning?: boolean | null = null;
  isLoading: boolean = true;
  isMessageVisible = false;
  isErrorVisible = false;
  username?: string | null;
  isAuthenticated = false;
  isAdmin = false;
  showGoProModal: boolean = false;

  message: string[] = [];
  error: string[] = [];

  constructor(
    private router: Router,
    private authService: AuthServiceService,
    private notificationService: NotificationService,
    public iconService: IconService
  ) { }

  ngOnInit(): void {

    this.authService.username$
      .pipe(takeUntil(this.destroy$))
      .subscribe(username => {
        this.username = username;
        this.isLoading = false;
      });

    this.authService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuthenticated => {
        this.isAuthenticated = isAuthenticated;
        this.isLoading = false;
      });

    this.authService.roles$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isAdmin = this.authService.hasRole('Admin');
      });

    this.subscriptions.add(
      this.notificationService.message$.subscribe(msg => {
        if (msg && msg.length > 0) {
          this.message = msg;
          this.resetNotificationTimer();
        }
      })
    );

    this.subscriptions.add(
      this.notificationService.error$.subscribe(err => {
        if (err && err.length > 0) {
          this.error = err;
          this.resetNotificationTimer();
        }
      })
    );
  }

  private resetNotificationTimer(): void {
    if (this.notificationTimeoutId) {
      clearTimeout(this.notificationTimeoutId);
    }
    this.isMessageVisible = this.message.length > 0;
    this.isErrorVisible = this.error.length > 0;
    this.notificationTimeoutId = setTimeout(() => {
      this.isMessageVisible = false;
      this.isErrorVisible = false;
      setTimeout(() => {
        this.message = [];
        this.error = [];
      }, 500); // matches the CSS transition duration
    }, 7000);
  }

  getBotStatus(): boolean {
    return this.isDiscordBotRunning ?? false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.unsubscribe();
  }

  logout(): void {
    this.authService.logOut();
  }

  collapseNavbar(): void {
    const navbar = document.getElementById('navbarSupportedContent');
    if (navbar && navbar.classList.contains('show')) {
      navbar.classList.remove('show');
    }
  }

  goPro(): void {
    this.showGoProModal = true;
  }
}
